/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Test
 * test for applicants to analytics team
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AnswerCreatePayloadRequest
 */
export interface AnswerCreatePayloadRequest {
    /**
     * 
     * @type {number}
     * @memberof AnswerCreatePayloadRequest
     */
    attempt: number;
    /**
     * 
     * @type {number}
     * @memberof AnswerCreatePayloadRequest
     */
    question: number;
    /**
     * 
     * @type {string}
     * @memberof AnswerCreatePayloadRequest
     */
    text: string;
    /**
     * 
     * @type {number}
     * @memberof AnswerCreatePayloadRequest
     */
    mcAnswer?: number;
}

/**
 * Check if a given object implements the AnswerCreatePayloadRequest interface.
 */
export function instanceOfAnswerCreatePayloadRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "attempt" in value;
    isInstance = isInstance && "question" in value;
    isInstance = isInstance && "text" in value;

    return isInstance;
}

export function AnswerCreatePayloadRequestFromJSON(json: any): AnswerCreatePayloadRequest {
    return AnswerCreatePayloadRequestFromJSONTyped(json, false);
}

export function AnswerCreatePayloadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnswerCreatePayloadRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'attempt': json['attempt'],
        'question': json['question'],
        'text': json['text'],
        'mcAnswer': !exists(json, 'mc_answer') ? undefined : json['mc_answer'],
    };
}

export function AnswerCreatePayloadRequestToJSON(value?: AnswerCreatePayloadRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'attempt': value.attempt,
        'question': value.question,
        'text': value.text,
        'mc_answer': value.mcAnswer,
    };
}

